// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1inrO","actions":"GroupTable_actions__3Dg3_","deleteModalFooter":"GroupTable_deleteModalFooter__1Zd6V"};